export default "__VITE_ASSET__Co$4RoSV__"